import { Button } from "@heroui/react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";
import { X } from "lucide-react";
import { LimitationTimeframe } from "@/server-types";
import { LimeNumberInput } from "@/Components/NextBase/LimeNumberInput";
import { LimeSelect } from "@/Components/NextBase/LimeSelect";

export default function LimitationsSection({
  parentIndex,
  limitations,
  onAddLimitation,
  onRemoveLimitation,
  onUpdateLimitation,
}: {
  parentIndex: number;
  limitations: Array<{
    timeframe: LimitationTimeframe;
    limitAmount: number;
  }>;
  onAddLimitation: (index: number) => void;
  onRemoveLimitation: (parentIndex: number, limitationIndex: number) => void;
  onUpdateLimitation: (
    parentIndex: number,
    limitationIndex: number,
    field: "timeframe" | "limitAmount",
    value: LimitationTimeframe | number,
  ) => void;
}) {
  return (
    <div className="flex flex-col gap-2">
      {limitations.map((limitation, index) => (
        <div key={index} className="flex flex-row items-end gap-2">
          <LimeSelect
            label={t`Časovni okvir`}
            labelPlacement="outside"
            placeholder={t`Izberi časovni okvir`}
            selectedKeys={[limitation.timeframe]}
            onSingleItemChange={(value) => {
              onUpdateLimitation(
                parentIndex,
                index,
                "timeframe",
                value as LimitationTimeframe,
              );
            }}
            variant="bordered"
            data-identifier={`subscription-service-limitation-timeframe-${parentIndex}-${index}`}
            items={[
              {
                label: t`Dan`,
                key: "day",
              },
              {
                label: t`Teden (pon-ned)`,
                key: "week",
              },
              {
                label: t`Celotno obdobje`,
                key: "all",
              },
            ]}
          ></LimeSelect>
          <LimeNumberInput
            variant="bordered"
            label={t`Št. obiskov`}
            labelPlacement="outside"
            placeholder={t`Št. obiskov`}
            value={limitation.limitAmount.toString()}
            data-identifier={`subscription-service-limitation-amount-${parentIndex}-${index}`}
            onValueChange={(value) =>
              onUpdateLimitation(parentIndex, index, "limitAmount", value)
            }
            minValue={0}
            step={1}
          />
          <Button
            isIconOnly
            variant="light"
            onPress={() => onRemoveLimitation(parentIndex, index)}
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      ))}
      <Button
        variant="flat"
        size="sm"
        onPress={() => onAddLimitation(parentIndex)}
      >
        <Trans>Dodaj omejitev</Trans>
      </Button>
    </div>
  );
}
